import { AboutHeroSection } from './components/AboutHeroSection'
import { StorySection } from './components/StorySection'
import { MissionVisionSection } from './components/MissionVisionSection'
import { ValuesSection } from './components/ValuesSection'
import { FounderSection } from './components/FounderSection'
import { CtaBanner } from '@/components/common/CtaBanner'

export function AboutFeature() {
  return (
    <>
      <AboutHeroSection />
      <StorySection />
      <MissionVisionSection />
      <ValuesSection />
      <FounderSection />
      <CtaBanner
        title="Ready to Build Something That Stands Above?"
        description="Whether you need custom internal software, a customer-facing product, or an architecture consultation — let us discuss your specifications."
        ctaText="Initiate Project Inquiry"
        ctaHref="/contact"
      />
    </>
  )
}
